import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import AnchorLink from 'react-anchor-link-smooth-scroll';

const NAV_LINKS = [
  { href: '#food', label: 'Food' },
  { href: '#whiskey', label: 'Whiskey Bible' },
  { href: '#spirits', label: 'Atmosphere' },
  { href: '#location', label: 'Location' },
  { href: '#contact', label: 'Contact' },
];

const ResponsiveAppBar = () => {
  const [anchorElNav, setAnchorElNav] = React.useState(null);

  const handleOpenNavMenu = (event) => setAnchorElNav(event.currentTarget);
  const handleCloseNavMenu = () => setAnchorElNav(null);

  return (
    <AppBar position="fixed" sx={{ backgroundColor: '#0f0c08ee', borderBottom: '1px solid #3a2f22' }}>
      <Container maxWidth="xl">
        <Toolbar disableGutters sx={{ overflow: 'hidden', justifyContent: 'space-between', minHeight: 62 }}>
          <AnchorLink href="#top" className="linkDestyle" style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <img
              src={process.env.PUBLIC_URL + 'images/nail.svg'}
              style={{ width: 42, height: 42, display: 'block' }}
              alt="The Rusty Nail"
            />
            <Typography
              variant="h6"
              noWrap
              sx={{
                fontSize: '15px',
                letterSpacing: '3.5px',
                fontWeight: 600,
                display: { xs: 'none', md: 'flex' },
                color: '#f5f0e6',
              }}
            >
              THE <span style={{ color: '#c5a26f', padding: '0 2px' }}>RUSTY</span> NAIL
            </Typography>
          </AnchorLink>

          {/* Mobile centered wordmark */}
          <AnchorLink
            href="#top"
            className="linkDestyle noSelect"
            style={{
              display: 'flex',
              flex: 1,
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Typography
              sx={{ display: { xs: 'flex', md: 'none' }, fontSize: '13px', letterSpacing: '2.5px' }}
              variant="h6"
            >
              THE <span style={{ color: '#c5a26f' }}>RUSTY</span> NAIL
            </Typography>
          </AnchorLink>

          {/* Mobile hamburger */}
          <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size="large"
              aria-label="Open menu"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
              keepMounted
              transformOrigin={{ vertical: 'top', horizontal: 'right' }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{ display: { xs: 'block', md: 'none' } }}
              PaperProps={{ sx: { backgroundColor: '#0f0c08', border: '1px solid #3a2f22' } }}
            >
              {NAV_LINKS.map((link) => (
                <AnchorLink key={link.href} href={link.href} className="linkDestyle">
                  <MenuItem onClick={handleCloseNavMenu} sx={{ fontSize: '13px', letterSpacing: '1px' }}>
                    {link.label}
                  </MenuItem>
                </AnchorLink>
              ))}
            </Menu>
          </Box>

          {/* Desktop nav */}
          <Box sx={{ display: { xs: 'none', md: 'flex' }, gap: 4 }}>
            {NAV_LINKS.map((link) => (
              <AnchorLink key={link.href} href={link.href} className="linkDestyle">
                <Button
                  onClick={handleCloseNavMenu}
                  sx={{
                    color: '#f5f0e6',
                    fontSize: '13px',
                    letterSpacing: '1.5px',
                    fontWeight: 500,
                    '&:hover': { color: '#c5a26f', background: 'transparent' },
                  }}
                >
                  {link.label}
                </Button>
              </AnchorLink>
            ))}
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default ResponsiveAppBar;